import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { configureAtomDevtools } from '../utils/tracking';
import { createPersistedStorage } from '../utils/persistence';
import type {
  ShogunDockedSize,
  ShogunFloatingRect,
} from '../../components/shogun/useShogunDock';

const SIDEBAR_STORAGE_KEY = 'localagent-sidebar-visible';
const SIDEBAR_WIDTH_STORAGE_KEY = 'localagent-sidebar-width';
const SIDEBAR_STORAGE_VERSION = 1;

export const sidebarVisibleAtom = configureAtomDevtools(
  atomWithStorage<boolean>(
    SIDEBAR_STORAGE_KEY,
    true,
    createPersistedStorage<boolean>({ version: SIDEBAR_STORAGE_VERSION })
  ),
  'layout/sidebarVisible'
);

export const sidebarWidthAtom = configureAtomDevtools(
  atomWithStorage<number>(
    SIDEBAR_WIDTH_STORAGE_KEY,
    220,
    createPersistedStorage<number>({ version: SIDEBAR_STORAGE_VERSION })
  ),
  'layout/sidebarWidth'
);

const CHAT_FILES_OPEN_STORAGE_KEY = 'localagent-chat-files-open';
const CHAT_DOCK_OPEN_STORAGE_KEY = 'localagent-chat-dock-open';
const CHAT_LAYOUT_STORAGE_VERSION = 1;

export const chatFilesOpenAtom = configureAtomDevtools(
  atomWithStorage<boolean>(
    CHAT_FILES_OPEN_STORAGE_KEY,
    true,
    createPersistedStorage<boolean>({ version: CHAT_LAYOUT_STORAGE_VERSION })
  ),
  'layout/chatFilesOpen'
);

export const chatDockOpenAtom = configureAtomDevtools(
  atomWithStorage<boolean>(
    CHAT_DOCK_OPEN_STORAGE_KEY,
    false,
    createPersistedStorage<boolean>({ version: CHAT_LAYOUT_STORAGE_VERSION })
  ),
  'layout/chatDockOpen'
);

const CHAT_DOCK_WIDTH_STORAGE_KEY = 'localagent-chat-dock-width';

export const chatDockWidthAtom = configureAtomDevtools(
  atomWithStorage<number>(
    CHAT_DOCK_WIDTH_STORAGE_KEY,
    380,
    createPersistedStorage<number>({ version: CHAT_LAYOUT_STORAGE_VERSION })
  ),
  'layout/chatDockWidth'
);

// Viewport-local Shogun geometry. Open/closed is the route's `forceOpen`, not
// an atom; dock mode is a UserPreferences field read by useShogunDock.
export const shogunFloatingRectAtom = configureAtomDevtools(
  atom<ShogunFloatingRect | null>(null),
  'layout/shogunFloatingRect',
);
// Docked-lane size (width for left/right docks, height for top/bottom). Null
// until seeded from the localStorage v2 geometry blob, same as the floating
// rect above.
export const shogunDockedSizeAtom = configureAtomDevtools(
  atom<ShogunDockedSize | null>(null),
  'layout/shogunDockedSize',
);

